module.exports = __webpack_public_path__ + "img/bg_recharge_info.8e1e572a.png";